import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState, } from 'react';
const ThemePreferenceContext = createContext(null);
const DEFAULT_STORAGE_KEY = 'syscolect:theme-mode';
function isThemePreference(value) {
    return value === 'light' || value === 'dark' || value === 'auto';
}
function defaultStorage() {
    if (typeof window === 'undefined' || !('localStorage' in window))
        return null;
    return window.localStorage;
}
export function ThemePreferenceProvider({ initial = 'auto', storageKey = DEFAULT_STORAGE_KEY, storage, children, }) {
    const resolvedStorage = storage === undefined ? defaultStorage() : storage;
    const [mode, setModeState] = useState(() => {
        if (!resolvedStorage)
            return initial;
        const stored = resolvedStorage.getItem(storageKey);
        return isThemePreference(stored) ? stored : initial;
    });
    const setMode = useCallback((next) => {
        setModeState(next);
    }, []);
    // Persist on change. Side-effect-only — does not touch any UI.
    useEffect(() => {
        if (!resolvedStorage)
            return;
        resolvedStorage.setItem(storageKey, mode);
    }, [resolvedStorage, storageKey, mode]);
    // Re-read when an injected backend notifies (e.g. preferences hydrate).
    useEffect(() => {
        if (!resolvedStorage?.subscribe)
            return;
        return resolvedStorage.subscribe(storageKey, () => {
            const stored = resolvedStorage.getItem(storageKey);
            if (isThemePreference(stored))
                setModeState(stored);
        });
    }, [resolvedStorage, storageKey]);
    return (_jsx(ThemePreferenceContext.Provider, { value: { mode, setMode }, children: children }));
}
export function useThemePreference() {
    const ctx = useContext(ThemePreferenceContext);
    if (!ctx) {
        throw new Error('useThemePreference must be used within a <ThemePreferenceProvider>.');
    }
    return ctx;
}
//# sourceMappingURL=ThemePreferenceContext.js.map